import { AllRoles, ManagerRoles, UserRole, IconsSubFolder, FeatureFlags } from '../../../types';

export const navbarLinks: Array<{
  label: string;
  href: string;
  matchExact?: boolean;
  matchPath?: string;
  iconSubFolder: IconsSubFolder;
  translation: string;
  requiredRoles?: Array<UserRole>;
  requiredFeatureFlags?: FeatureFlags;
}> = [
  {
    label: 'assistant',
    href: '/app',
    matchExact: true,
    iconSubFolder: '12-assistant',
    translation: 'global:header:nav:assistant',
    requiredRoles: [UserRole.SVCUSR, UserRole.SVCUSR_SPR],
  },
  {
    label: 'tasks',
    href: '/app/tasks',
    iconSubFolder: '01-tasks',
    translation: 'global:header:nav:tasks',
    requiredRoles: AllRoles,
  },
  {
    label: 'people',
    href: '/app/people/users',
    matchPath: '/app/people',
    iconSubFolder: '03-people',
    translation: 'global:header:nav:people',
    requiredRoles: [...ManagerRoles, UserRole.SUPP_SPR, UserRole.SVCUSR_SPR],
  },
  {
    label: 'assets',
    href: '/app/assets',
    iconSubFolder: '02-assets',
    translation: 'global:header:nav:assets',
    requiredRoles: AllRoles,
  },
  {
    label: 'performance-stats',
    href: '/app/performance-stats',
    iconSubFolder: '04-dashboard',
    translation: 'global:header:nav:dashboard',
    requiredRoles: [...ManagerRoles, UserRole.SUPP_SPR, UserRole.SVCUSR_SPR],
    requiredFeatureFlags: FeatureFlags.PERF_STATS,
  },
];
